<template>
  <div>
    <Pos_promotion_list/>
  </div>
</template>

<script>
import Pos_promotion_list from "@/components/adminArin/pos_system/warehouse/manage_promotion/Pos_promotion_list";
export default {
  name: "PosPromotionList",
  components: {
    Pos_promotion_list
  }
}
</script>

<style scoped>

</style>
